import { Alerts, Breadcrumbs } from '.';
import { Button, IconButton } from '../forms';
import { ButtonVariantEnum, EnvironmentEnum } from '../../enums';
import { FunctionComponent, useEffect } from 'react';
import { useAlert, useAuth } from '../../hooks';

import { BaseLayoutType } from '../../types';
import { FaPowerOff } from 'react-icons/fa';
import Footer from './Footer';
import Navbar from './Navbar';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BaseLayout: FunctionComponent<BaseLayoutType> = ({ children }): JSX.Element => {
  const { t } = useTranslation();
  const { authenticated, user, login, logout } = useAuth();
  const { alerts } = useAlert();
  const navigate = useNavigate();

  useEffect(() => {
    if (alerts.length > 0) {
      window.scrollTo(0, 0);
    }
  }, [alerts]);

  return (
    <div>
      <header>
        <Navbar logoLink={authenticated ? `/eleicoes` : `/`}>
          {authenticated ? (
            <div className="d-flex">
              <span className="fw-bold align-middle px-2">{user?.nome}</span>
              <img src={user?.foto} alt="mdo" width="28" height="28" className="rounded-circle" />

              <IconButton
                title={t('label.sair')}
                variant={ButtonVariantEnum.WARNING}
                circle
                className="ms-2 text-white"
                onClick={() => {
                  logout(() => navigate('/'));
                }}
                Icon={FaPowerOff}
              />
            </div>
          ) : (
            <Button
              title={t('label.entrar')}
              variant={ButtonVariantEnum.WARNING}
              onClick={() => {
                if (process.env.REACT_APP_ENV === EnvironmentEnum.REVIEW_APP) {
                  login(() => navigate('/eleicoes'));
                } else {
                  window.location.href = `${process.env.REACT_APP_AUTHSERVER_URL}/oauth/authorize?client_id=sce&scope=personal-read&response_type=code&redirect_uri=${process.env.REACT_APP_REDIRECT_URL}`;
                }
              }}
              className={'text-primary-700 border border-primary'}
            />
          )}
        </Navbar>
      </header>
      <Breadcrumbs />
      <Alerts />
      <main>
        <div className="container-fluid px-0">{children}</div>
      </main>
      <Footer />
    </div>
  );
};

export default BaseLayout;
